import PaymentAdvancesTab from "@/features/billingBills/components/PaymentAdvancesTab";
import DocumentsTab from "../components/DocumentsTab";
import EventsTab from "../components/EventsTab";
import ResumeTab from "../components/ResumeTab";

export const billingBillTabs = [
  {
    label: 'Resumo',
    value: '',
    body: <ResumeTab />,
  },
  {
    label: 'Nota fiscal / Cobranças',
    value: 'documents',
    body: <DocumentsTab />,
  },
  {
    label: 'Transações',
    value: 'events',
    body: <EventsTab />,
  },
  {
    label: 'Antecipáveis',
    value: 'payment-advances',
    body: <PaymentAdvancesTab />,
  },
];
